import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const PressSharedDocuments = () => {
    return <SharedDocumentsComponent permissionId="15" path="Imprensa" />
}